import Vue from 'vue';
import { env, Runtime } from './env';

interface ICATErrorModel {
  level?: 'error' | 'info' | 'warn' | 'debug';
  category?: string;
  tags?: any;
}

class Monitor {
  private config: object;
  private extInfo: object;

  constructor(extInfo: object, isDebug: boolean) {
    this.extInfo = extInfo;
    this.config = {
      project: 'pay-sdk-inside-pages',
      pageUrl: `${location.protocol}//${location.host}${location.pathname}`,
      devMode: isDebug,
      resource: {
        sampleApi: 1,
        delay: 0
      },
      page: {
        auto: true,
        sample: 1,
        delay: 0
      },
      error: {
        sample: 1,
        combo: false
      },
      ajax: {
        flag: true,
        duration: 8000
      },
      metric: {
        sample: 1,
        combo: true
      },
      logan: {
        enable: false
      },
      noScriptError: false,
      onErrorPush(error: any) {
        return error.updateTags({
          ...extInfo
        });
      }
    };

    this.start();
  }

  captureMessage(error: string | SubErrorType, config?: ICATErrorModel) {
    console.error(error);
    if (window.Owl) {
      const baseConfig: ICATErrorModel = {
        level: 'info',
        category: 'custom_info'
      };

      window.Owl.addError(error, {
        ...baseConfig,
        ...config
      });
    }
  }

  captureAjaxErrorMessage(message: string | SubErrorType, tags?: any) {
    this.captureMessage(message, {
      tags,
      level: 'error',
      category: 'ajaxError'
    });
  }

  captureJSErrorMessage(message: string | SubErrorType, tags?: any) {
    this.captureMessage(message, {
      tags,
      level: 'error',
      category: 'jsError'
    });
  }

  captureResourceInfoMessage(message: string | SubErrorType, tags?: any) {
    this.captureMessage(message, {
      tags,
      level: 'info',
      category: 'resourceError'
    });
  }

  reportMetric(key: string, tags = {}, value?: any): void {
    if (window.Owl) {
      const metricManager = window.Owl.metricManager;
      metricManager.setTags({
        ...this.extInfo,
        ...tags
      });
      metricManager.setMetric(key, value || 1);
      // 强制上报所有
      metricManager.report();
    }
  }

  reportPoint(position: number, duration = null): void {
    if (window.Owl) {
      const param: CustomPoint = { position };
      if (duration) {
        param.duration = duration || 0;
      }
      window.Owl.addPoint(param);
      window.Owl.sendPoints();
    }
  }

  vueErrorHandler(err: Error, vm: Vue, msg: string) {
    if (!err) {
      console.warn('未捕获异常');
      return;
    }
    // 为保证报错在控制台展示
    console.error(err);
    const error = {
      name: `【vueErrorHandler】${msg}${err.name}`,
      msg: { res: err.stack || err.message, url: err.name } // 只上报类型，vm 里的数据由于数据量大不再上报
    };
    const opts = {
      category: 'jsError'
    };
    if (window.Owl) {
      window.Owl.addError(error, {
        ...opts
      });
    }
  }

  private start() {
    if (window.Owl) {
      window.Owl.start(this.config);
    }
  }
}

const info = {
  ...env.commonParams,
  payMemberId: env.payMemberId,
  customId: env.customId,
  bizId: env.bizId,
  needHandIdPhoto: env.needHandIdPhoto,
  userid: env.userid
};

export const monitor = new Monitor(info, env.runtime !== Runtime.Prod);
